import React from 'react';
import { useSelector } from 'react-redux';
import ProfileWrapper from './components/ProfileWrapper/ProfileWrapper';
import JobAlerts from './components/JobAlerts';

// temporarily commented
// import AirswiftAlerts from './components/AirswiftAlerts';
// import MyApplicationsAlerts from './components/MyApplicationsAlerts';
// import TimeAndExpenseAlerts from './components/TimeAndExpenseAlerts';
// import classes from './alerts.module.scss';

function Alerts() {
  const profile = useSelector((state) => state.user.profile);
  const profileError = useSelector((state) => state.user.error);
  const profilePending = useSelector((state) => state.user.pendingFlag);

  const userId = localStorage.getItem('UserId');

  return (
    <ProfileWrapper profile={profile} error={profileError} pending={profilePending} userId={userId}>
      <JobAlerts />
      {/* temporarily commented */}
      {/* <hr className={classes.divider} /> */}
      {/* <AirswiftAlerts /> */}
      {/* <hr className={classes.divider} /> */}
      {/* <MyApplicationsAlerts /> */}
      {/* <hr className={classes.divider} /> */}
      {/* <TimeAndExpenseAlerts /> */}
    </ProfileWrapper>
  );
}

export default Alerts;
